<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <span class="title dialog-title">{{ dialogTitle() | translate }}</span>
    <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" ngForm #taskForm="ngForm">
    @if (error()) {
      <p role="alert">{{ error() | translate }}</p>
    }
    @if (data.type === 'group' && role() === 'superAdmin') {
      <mat-form-field>
        <mat-label>{{ 'event.country' | translate }}</mat-label>
        <mat-select name="countryId" [(ngModel)]="location.countryId" (selectionChange)="countryChanged()" required>
          @for (country of countries(); track country.id) {
            <mat-option [value]="country.id">{{ country.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (data.type === 'group' && (role() === 'superAdmin' || role() === 'countryAdmin')) {
      <mat-form-field>
        <mat-label>{{ 'event.canton' | translate }}</mat-label>
        <mat-select name="cityId" [(ngModel)]="location.cityId" (selectionChange)="cityChanged()"
                    [disabled]="!location.countryId" required>
          @for (city of cities(); track city.id) {
            <mat-option [value]="city.id">{{ city.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (data.type === 'group' && (role() === 'superAdmin' || role() === 'countryAdmin' || role() === 'subCountryAdmin')) {
      <mat-form-field>
        <mat-label>{{ 'event.organization' | translate }}</mat-label>
        <mat-select name="organizationId" [(ngModel)]="location.organizationId" [disabled]="!location.cityId" required>
          @for (organization of organizations(); track organization.id) {
            <mat-option [value]="organization.id">{{ organization.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <mat-form-field>
      <mat-label>{{ 'taskGroup.name' | translate }}</mat-label>
      <input matInput name="title" [ngModel]="title()" (ngModelChange)="title.set($event)" required>
    </mat-form-field>
    @if (data.type === 'task') {
      <mat-form-field>
        <mat-label>{{ 'taskGroup.description' | translate }}</mat-label>
        <textarea matInput name="description" cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5"
                  [ngModel]="description()" (ngModelChange)="description.set($event)"></textarea>
      </mat-form-field>
      <div class="deadline-fields">
        <mat-form-field>
          <mat-label>{{ 'taskGroup.deadline' | translate }}</mat-label>
          <input matInput name="deadlineDate" [matDatepicker]="deadlinePicker" [ngModel]="deadline()"
                 (ngModelChange)="deadline.set($event)">
          <mat-datepicker #deadlinePicker/>
          <mat-datepicker-toggle [for]="deadlinePicker" matSuffix/>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'taskGroup.time' | translate }}</mat-label>
          <input matInput name="deadlineTime" [matTimepicker]="deadlineTimePicker" [ngModel]="deadline()"
                 (ngModelChange)="deadline.set($event)" [disabled]="!deadline()">
          <mat-timepicker #deadlineTimePicker/>
          <mat-timepicker-toggle [for]="deadlineTimePicker" matSuffix/>
        </mat-form-field>
      </div>
    }
  </div>

  <div mat-dialog-actions class="m-0 p-16" align="end">
    <button mat-button (click)="dialogRef.close()">{{ 'main.cancel' | translate }}</button>
    <button mat-raised-button class="mat-accent" (click)="save()"
            [disabled]="!title().trim() || taskForm.invalid || (data.type === 'group' && (!location.countryId || !location.cityId || !location.organizationId))">
      {{ 'main.save' | translate }}
    </button>
  </div>
</div>
